import styles from './styles.module.scss';
import Spring from '@/components/Spring';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useTheme } from '@/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import dark404 from '@/assets/404dark.webp';
import light404 from '@/assets/404light.webp';

const Error404 = () => {
  const { theme } = useTheme();
  const { t } = useTranslation('common');
  const { isAuthenticated } = useAuth();

  return (
    <Spring className={`${styles.container} card d-flex align-items-center flex-1`}>
      <div className={styles.media}>
        <img
          className={classNames(styles.media_img, { [styles.visible]: theme === 'light' })}
          src={light404}
          alt="404"
        />
        <img
          className={classNames(`${styles.media_img} ${styles.dark}`, { [styles.visible]: theme === 'dark' })}
          src={dark404}
          alt="404"
        />
      </div>
      <div className={styles.main}>
        <h2 className={styles.main_title} data-testid="error-404-title">
          {t('oops')} <span>{t('pageNotFound')}</span>
        </h2>
        <p className={styles.main_text}>
          {t('checkUrl')}
        </p>
        <NavLink className="ls-btn" data-testid="error-404-home" to={isAuthenticated ? '/dashboard' : '/'}>{t('home')}</NavLink>
      </div>
    </Spring>
  );
};

export default Error404;
